import { keyedString } from './helperTypes';

export interface ErrorService {
  init: (options: keyedString) => void;
  error: (error: Error, data?: keyedString) => void;
  log: (name: string, data?: keyedString) => void;
  warn: (name: string, data?: keyedString) => void;
  identify: (uid: string, data?: keyedString) => void;
  anonIdentify: (data: keyedString) => void;
}
export class ErrorLogger {
  constructor(private loggerService: ErrorService) {}
  withConsole = true;
  init(options: any): void {
    if (options?.overrideConsole) {
      this.overrideConsole();
    }
    if (this.withConsole) {
      console.log('[LOGGER] INIT', options);
    }
    this.loggerService.init(options);
  }

  private overrideConsole(): void {
    this.withConsole = false;
    window['console']['log'] = (msg: any, data: any) => this.log(msg, data);
    window['console']['warn'] = (msg: any, data: any) => this.warn(msg, data);
    window['console']['error'] = (msg: any, data: any) => this.error(msg, data);
  }

  error(error: Error, data?: keyedString): void {
    if (this.withConsole) {
      console.error('[LOGGER] ERROR', error);
    }
    this.loggerService.error(error, data);
  }
  log(name: string, data?: keyedString): void {
    if (this.withConsole) {
      console.log('[LOGGER] LOG', name, data);
    }
    this.loggerService.log(name, data);
  }
  warn(name: string, data?: keyedString): void {
    if (this.withConsole) {
      console.warn('[LOGGER] WARN', name, data);
    }
    this.loggerService.warn(name, data);
  }
  identify(uid: string, data?: keyedString): void {
    if (this.withConsole) {
      console.log('[LOGGER] IDENTIFY', uid, data);
    }
    this.loggerService.identify(uid, data);
  }
  anonIdentify(data: keyedString): void {
    if (this.withConsole) {
      console.log('[LOGGER] IDENTIFY', data);
    }
    this.loggerService.anonIdentify(data);
  }
}

// No-op backing service. ErrorLogger already does its own `[LOGGER]` console
// logging, so the backing service has no work to do — every method is a no-op.
// Previously this was a Sentry-backed implementation; Sentry was removed
// because the ingest backend is being decommissioned (PEN-997). The factory
// signature `(vueInstance?) => ErrorService` is preserved so main.js's
// `new ErrorLogger(logger(app))` call site is unchanged.
export const logger = (_vueInstance?: unknown): ErrorService => ({
  init: () => {
    return;
  },
  error: () => {
    return;
  },
  log: () => {
    return;
  },
  warn: () => {
    return;
  },
  identify: () => {
    return;
  },
  anonIdentify: () => {
    return;
  },
});
